export default {
  fr: {
    currency: {
      style: 'currency',
      currency: 'EUR',
      minimumFractionDigits: 0,
    },
  },
};
